// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3638":"b7771204e33f8371","3641":"22ecf9d1952bd2fa","4758":"b5cad1562948d32f","9653":"6710f2af1e162b9a"}[chunkId] + ".css";
};